var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjectsettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.052,
    height: 19.059,
    viewBox: "0 0 15.052 19.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(-36.183 -304.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_File_3731163",
    transform: "translate(18.707 286.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M28.975,29.128a.371.371,0,0,0,.278-.459,4.4,4.4,0,0,0-.428-1.034.37.37,0,0,0-.521-.127.791.791,0,0,1-.985-.985A.37.37,0,0,0,27.192,26a4.4,4.4,0,0,0-1.034-.428.37.37,0,0,0-.459.278.791.791,0,0,1-1.394,0,.37.37,0,0,0-.459-.278A4.391,4.391,0,0,0,22.813,26a.37.37,0,0,0-.127.521.791.791,0,0,1-.985.986.376.376,0,0,0-.288-.049.37.37,0,0,0-.233.175,4.387,4.387,0,0,0-.428,1.034.371.371,0,0,0,.278.459.791.791,0,0,1,0,1.394.37.37,0,0,0-.278.459,4.387,4.387,0,0,0,.428,1.034.37.37,0,0,0,.522.126.791.791,0,0,1,.985.986.37.37,0,0,0,.127.521,4.378,4.378,0,0,0,1.034.427.37.37,0,0,0,.458-.278.792.792,0,0,1,1.394,0,.37.37,0,0,0,.458.278,4.373,4.373,0,0,0,1.034-.427.37.37,0,0,0,.127-.521.791.791,0,0,1,.985-.985.376.376,0,0,0,.288.048.37.37,0,0,0,.233-.175,4.4,4.4,0,0,0,.428-1.034.37.37,0,0,0-.278-.459.792.792,0,0,1,0-1.394Zm-.531,1.958q-.052.143-.116.28a1.585,1.585,0,0,0-1.784,1.784q-.137.063-.28.116a1.585,1.585,0,0,0-2.523,0q-.143-.052-.28-.116a1.584,1.584,0,0,0-1.784-1.784q-.063-.138-.116-.28a1.585,1.585,0,0,0,0-2.523c.035-.1.073-.189.116-.28A1.585,1.585,0,0,0,23.461,26.5q.137-.063.28-.116a1.584,1.584,0,0,0,2.523,0q.143.052.28.116a1.585,1.585,0,0,0,1.784,1.784q.063.137.116.28a1.585,1.585,0,0,0,0,2.523Z",
    fill: "#005e98",
    stroke: "#005e98",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M27.7,30.559a1.963,1.963,0,1,0,1.963,1.963A1.965,1.965,0,0,0,27.7,30.559Zm0,3.186a1.223,1.223,0,1,1,1.223-1.223A1.225,1.225,0,0,1,27.7,33.745Z",
    transform: "translate(-2.697 -2.697)",
    fill: "#005e98",
    stroke: "#005e98",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(30.2 304.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M28.235,15.5a.627.627,0,0,0-.032-.184c0-.011-.006-.022-.01-.032a.638.638,0,0,0-.094-.165l-.008-.014L23.7,9.762c-.006-.008-.014-.013-.021-.02a.551.551,0,0,0-.055-.054c-.014-.012-.028-.025-.042-.036a.618.618,0,0,0-.068-.042c-.015-.008-.029-.017-.045-.025a.665.665,0,0,0-.085-.03c-.014,0-.026-.009-.039-.012a.658.658,0,0,0-.13-.014H13.819a.636.636,0,0,0-.636.636V27.952a.636.636,0,0,0,.636.636H27.6a.636.636,0,0,0,.636-.636V15.5Zm-4.394-3.559,2.411,2.932H23.841ZM14.455,27.316V10.8h8.113v4.707a.636.636,0,0,0,.636.636h3.758V27.316Z",
    transform: "translate(-7.2 -9.529)",
    fill: "#005e98"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectsettings);
export default __webpack_public_path__ + "static/media/Icon-Project settings.e6d2b5901222ab0a0d373cfdaa709e78.svg";
export { ForwardRef as ReactComponent };